import types from '../types/phone'
import missingInfoTypes from '../types/missingInfo'
import {User as userTypes} from '../../../state/types'
import {Map} from 'immutable'

const initialNumber = Map({
  isSaving: false,
  value: '',
  error: '',
})

function number(state = initialNumber, action) {
  switch (action.type) {
    case missingInfoTypes.NEXT_STEP:
      return state.merge(initialNumber)
    case types.SET_PHONE_NUMBER:
      return state.set('value', action.payload.value)
    case types.SEND_SMS:
      return state.merge({
        isSaving: true,
        error: '',
      })
    case types.SEND_SMS_SUCCESS:
      return state.merge({
        isSaving: false,
        error: '',
      })
    case types.SEND_SMS_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

const initialCode = Map({
  isSaving: false,
  value: '',
  error: '',
})

function code(state = initialCode, action) {
  switch (action.type) {
    case missingInfoTypes.NEXT_STEP:
      return state.merge(initialCode)
    case types.SET_CODE:
      return state.set('value', action.payload.value)
    case types.CONFIRM:
      return state.merge({
        isSaving: true,
        error: '',
      })
    case types.CONFIRM_SUCCESS:
      return state.merge({
        isSaving: false,
        error: '',
      })
    case types.CONFIRM_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

const initialRoot = Map({
  tab: 1,
  isUpdating: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case missingInfoTypes.NEXT_STEP:
      return state.merge(initialRoot)
    case types.SET_TAB:
      return state.set('tab', action.payload.tab)
    case types.SEND_SMS_SUCCESS:
      return state.set('tab', 2)
    case userTypes.UPDATE_MISSING_INFO:
      return state.merge({
        isUpdating: true,
        error: '',
      })
    case userTypes.UPDATE_MISSING_INFO_SUCCESS:
      return state.merge({
        isUpdating: false,
        error: '',
      })
    case userTypes.UPDATE_MISSING_INFO_FAIL:
      return state.merge({
        isUpdating: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

export default function(state, action) {
  const m = Map({
    number: number(state ? state.get('number') : undefined, action),
    code: code(state ? state.get('code') : undefined, action),
  })
  return root(state, action).merge(m)
}



// WEBPACK FOOTER //
// ./src/sections/missingInfo/reducers/phone.js